let FrameAreaValue = /*#__PURE__*/function (FrameAreaValue) {
  FrameAreaValue["Frame"] = "frame";
  FrameAreaValue["Header"] = "header";
  FrameAreaValue["Footer"] = "footer";
  FrameAreaValue["Main"] = "main";
  FrameAreaValue["PrimaryAction"] = "primaryAction";
  FrameAreaValue["SecondaryAction"] = "secondaryAction";
  FrameAreaValue["PrimaryPanel"] = "primaryPanel";
  FrameAreaValue["SecondaryPanel"] = "secondaryPanel";
  return FrameAreaValue;
}({});

// TODO: Is there a way to simply state that this
// interface accepts any key > value from FrameAreaValue

export { FrameAreaValue };
